<template>
  <div
    class="super-discount-banner"
    data-testid="discount-popup"
  >
    <div class="super-discount-banner__wrapper">
      <div class="super-discount-banner__header">
        <CNuxtImg
          src="logo_dark_bg.webp"
          alt="white logo"
          min-height="28px"
          localize
        />
      </div>
      <div class="super-discount-banner__image-wrapper">
        <CNuxtImg
          src="/images/super-discount.webp"
          alt="super discount"
          class="super-discount-banner__image"
          min-height="300px"
        />
      </div>
      <h2 class="super-discount-banner__title title-24-800 text-center">
        {{ $t('super_discount_title') }}
      </h2>
      <p class="super-discount-banner__text paragraph_14-400">
        {{ $t('super_discount_body_1', [$t(mainGoal)]) }}
      </p>
      <p
        class="super-discount-banner__text paragraph_14-400"
        v-html="$t('super_discount_body_2')"
      />
      <base-button
        type="red"
        rounded="full"
        with-shadow
        class="super-discount-banner__button"
        data-testid="got-it-super-discount-btn"
        @click="emits('close')"
      >
        {{ $t('super_discount_got_it_button') }}
      </base-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emits = defineEmits(['close']);
const { goals } = useQuiz();

const mainGoal = computed(() => {
  if (!goals.value?.main) {
    return 'goal_erectile_function';
  }
  return goals.value.main;
});
</script>

<style lang="scss" scoped>
.super-discount-banner {
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: $text-color;
  z-index: 9999;

  &__wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    padding: 24px 32px 120px 32px;
    overflow-y: auto;
  }

  &__header {
    display: flex;
    justify-content: flex-start;
    min-height: 28px;

    img {
      width: 120px;
    }
  }

  &__image-wrapper {
    min-height: 300px;
    min-width: 311px;
  }

  &__image {
    display: block;
    width: 100%;
  }

  &__title {
    padding: 0 8px 8px 8px;
    font-weight: 700;
    color: $white;
  }

  &__text {
    color: $white;
    margin-top: 16px;
  }

  &__button {
    margin-top: 32px;
  }
}
</style>
